import React from 'react';
import styles from './bodywon.module.css';
import { useAddBanner } from '../context/AddBannerContext';

/**
 * Full-width storefront banner for Add Banner slots 1, 3, 4, 5.
 * Only renders when an active banner exists for displayOrder.
 */
const AddBannerStrip = ({ displayOrder, className = '' }) => {
  const banner = useAddBanner(displayOrder);

  if (!banner?.imageSrc) return null;

  const img = (
    <img
      src={banner.imageSrc}
      alt={banner.title}
      className={styles.offerBannerImage}
    />
  );

  return (
    <section className={`${styles.offerBannerSection} ${className}`.trim()}>
      {banner.redirectUrl ? (
        <a href={banner.redirectUrl} style={{ display: 'block' }}>
          {img}
        </a>
      ) : (
        img
      )}
    </section>
  );
};

export default AddBannerStrip;
